export default function CancellationPolicy() {
  return (
    <div className="bg-gradient-to-b from-gray-50 to-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-red-500 to-red-600 rounded-full mb-4 animate-float">
            <i className="ri-file-warning-line text-white text-2xl"></i>
          </div>
          <h2 className="text-4xl font-bold text-[#0D1B3E] mb-4">İptal Koşulları</h2>
          <p className="text-lg text-red-600 font-semibold">
            Lütfen iptal şartlarını dikkatli okuyunuz.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* İptal Tarihleri */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-red-200 animate-slide-up">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <i className="ri-calendar-close-line text-red-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0D1B3E]">İptal Tarihleri</h3>
            </div>

            <div className="space-y-6">
              <div className="bg-green-50 border-l-4 border-green-500 rounded-lg p-5">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-green-600 text-2xl mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="font-bold text-green-900 mb-2">25 Mart 2026 Öncesi</p>
                    <p className="text-sm text-green-800 leading-relaxed mb-2">
                      25 Mart 2026 tarihine kadar iptal yapılabilir. Bu tarihten önce yapılan iptallerde kongre kayıt ücretinin <strong>banka masrafları ve kanuni kesintileri yapıldıktan sonra iade işlemi yapılacaktır.</strong>
                    </p>
                    <p className="text-sm text-green-800 leading-relaxed">
                      <strong>Sadece teorik oturum iptali kabul edilmekte ve iadesi yapılmaktadır,</strong> pratik oturumların iptali kabul edilmeyecektir.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-red-50 border-l-4 border-red-500 rounded-lg p-5">
                <div className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-600 text-2xl mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="font-bold text-red-900 mb-2">25 Mart 2026 Sonrası</p>
                    <p className="text-sm text-red-800 leading-relaxed mb-2">
                      25 Mart 2026 sonrası <strong>iptal kabul edilmemektedir.</strong> Ancak isim değişikliği yapılabilir.
                    </p>
                    <p className="text-sm text-red-800 leading-relaxed">
                      <strong>İsim değişiklik hakkı sadece teorik oturumlar için geçerlidir,</strong> pratik oturumlarda isim değişikliği kabul edilmemektedir.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* İsim Değişikliği & İade */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-orange-200 animate-slide-up-delay">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                <i className="ri-user-shared-line text-orange-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0D1B3E]">İsim Değişikliği & İade</h3>
            </div>

            <div className="space-y-6">
              <div className="bg-teal-50 border-l-4 border-[#1A9B8C] rounded-lg p-5">
                <div className="flex items-start gap-3">
                  <i className="ri-time-line text-[#1A9B8C] text-2xl mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="font-bold text-teal-900 mb-2">İade Süresi</p>
                    <p className="text-sm text-teal-800 leading-relaxed">
                      İade işlemleri kongre gerçekleştikten sonra <strong>20 iş günü içerisinde</strong> yapılacaktır.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Önemli Hatırlatma */}
        <div className="bg-gradient-to-r from-[#0D1B3E] to-[#1a2f5a] rounded-2xl p-8 text-white shadow-2xl animate-fade-in">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-[#C9A84C] rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-alert-line text-white text-3xl"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-4">Önemli Hatırlatma</h3>
              <div className="space-y-3 text-gray-200 leading-relaxed">
                <p>
                  <i className="ri-arrow-right-s-line text-[#C9A84C]"></i> İptal ve iade işlemleri için <strong>serkan@identaevent.com</strong> adresine e-posta göndermeniz gerekmektedir.
                </p>
                <p>
                  <i className="ri-arrow-right-s-line text-[#C9A84C]"></i> İsim değişikliği talepleri için kayıt numaranızı ve yeni katılımcı bilgilerini bildirmeniz gerekmektedir.
                </p>
                <p>
                  <i className="ri-arrow-right-s-line text-[#C9A84C]"></i> Banka masrafları ve yasal kesintiler iade tutarından düşülecektir.
                </p>
                <p>
                  <i className="ri-arrow-right-s-line text-[#C9A84C]"></i> İade işlemleri kongre sonrası <strong>20 iş günü</strong> içerisinde tamamlanacaktır.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* İletişim CTA */}
        <div className="mt-12 text-center animate-fade-in">
          <p className="text-lg text-gray-700 mb-6">
            İptal ve iade işlemleri hakkında detaylı bilgi almak için bizimle iletişime geçebilirsiniz.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="mailto:serkan@identaevent.com"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#1A9B8C] to-[#15806f] text-white px-8 py-4 rounded-lg font-semibold hover:shadow-xl transition-all whitespace-nowrap"
            >
              <i className="ri-mail-line text-xl"></i>
              <span>E-posta Gönder</span>
            </a>
            <a
              href="tel:+905350670675"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0D1B3E] to-[#1a2f5a] text-white px-8 py-4 rounded-lg font-semibold hover:shadow-xl transition-all whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>+90 535 067 06 75</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
